/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import { ChevronDownIcon, RemoveIcon, ChevronUpIcon, AddIcon } from 'tdesign-icons-react';
import classNames from 'classnames';
import { Input } from '../input/index.js';
import { Button } from '../button/index.js';
import useInputNumber from './useInputNumber.js';
import useGlobalIcon from '../hooks/useGlobalIcon.js';
import { inputNumberDefaultProps } from './defaultProps.js';
import '../input/Input.js';
import '../_chunks/dep-92728dc5.js';
import '../_chunks/dep-e43cf21c.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import '../_util/useLayoutEffect.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-7dce2c26.js';
import '../_util/easing.js';
import '../_util/forwardRefWithStatics.js';
import 'hoist-non-react-statics';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../input/InputGroup.js';
import '../hooks/useControlled.js';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-c1f93350.js';
import '../_util/noop.js';
import '../locale/LocalReceiver.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../input/defaultProps.js';
import '../_util/parseTNode.js';
import '../input/useLengthLimit.js';
import '../_common/js/log/index.js';
import '../_common/js/log/log.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../input/style/css.js';
import '../input/type.js';
import '../button/Button.js';
import '../hooks/useDomRefCallback.js';
import '../_util/useRipple.js';
import '../_util/useAnimation.js';
import '../_util/setStyle.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../common/Portal.js';
import 'react-dom';
import '../loading/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-e0370ebe.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../button/defaultProps.js';
import '../button/style/css.js';
import '../button/type.js';
import '../_util/useCommonClassName.js';
import '../_common/js/input-number/number.js';
import '../_chunks/dep-a827ffec.js';
import '../_common/js/input-number/large-number.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function TdInputNumber(props, ref) {
  var _useGlobalIcon = useGlobalIcon({
      ChevronDownIcon: ChevronDownIcon,
      RemoveIcon: RemoveIcon,
      ChevronUpIcon: ChevronUpIcon,
      AddIcon: AddIcon
    }),
    ChevronDownIcon$1 = _useGlobalIcon.ChevronDownIcon,
    RemoveIcon$1 = _useGlobalIcon.RemoveIcon,
    ChevronUpIcon$1 = _useGlobalIcon.ChevronUpIcon,
    AddIcon$1 = _useGlobalIcon.AddIcon;
  var _useInputNumber = useInputNumber(props),
    classPrefix = _useInputNumber.classPrefix,
    wrapClasses = _useInputNumber.wrapClasses,
    addClasses = _useInputNumber.addClasses,
    reduceClasses = _useInputNumber.reduceClasses,
    listeners = _useInputNumber.listeners,
    isError = _useInputNumber.isError,
    inputRef = _useInputNumber.inputRef,
    userInput = _useInputNumber.userInput,
    handleAdd = _useInputNumber.handleAdd,
    handleReduce = _useInputNumber.handleReduce,
    onInnerInputChange = _useInputNumber.onInnerInputChange;
  var wrapRef = useRef(null);
  var status = isError ? "error" : props.status;
  var addIcon = props.theme === "column" ? /* @__PURE__ */React.createElement(ChevronUpIcon$1, {
    size: props.size
  }) : /* @__PURE__ */React.createElement(AddIcon$1, {
    size: props.size
  });
  var reduceIcon = props.theme === "column" ? /* @__PURE__ */React.createElement(ChevronDownIcon$1, {
    size: props.size
  }) : /* @__PURE__ */React.createElement(RemoveIcon$1, {
    size: props.size
  });
  useImperativeHandle(ref, function () {
    return {
      currentElement: wrapRef.current,
      inputElement: inputRef.current
    };
  });
  return /* @__PURE__ */React.createElement("div", {
    className: classNames(wrapClasses, props.className),
    style: props.style,
    ref: wrapRef
  }, props.theme !== "normal" && /* @__PURE__ */React.createElement(Button, {
    className: reduceClasses,
    disabled: props.disabled,
    onClick: handleReduce,
    variant: "outline",
    shape: "square",
    icon: reduceIcon
  }), /* @__PURE__ */React.createElement(Input, _objectSpread(_objectSpread({
    ref: inputRef,
    autocomplete: "off",
    disabled: props.disabled,
    readonly: props.readonly,
    placeholder: props.placeholder,
    autoWidth: props.autoWidth,
    align: props.align || (props.theme === "row" ? "center" : void 0),
    status: status,
    label: props.label,
    suffix: props.suffix,
    value: userInput,
    onChange: onInnerInputChange,
    size: props.size
  }, listeners), props.inputProps || {})), props.theme !== "normal" && /* @__PURE__ */React.createElement(Button, {
    className: addClasses,
    disabled: props.disabled,
    onClick: handleAdd,
    variant: "outline",
    shape: "square",
    icon: addIcon
  }), props.tips && /* @__PURE__ */React.createElement("div", {
    className: classNames("".concat(classPrefix, "-input__tips"), "".concat(classPrefix, "-input__tips--").concat(status))
  }, props.tips));
}
var InputNumber = /*#__PURE__*/forwardRef(TdInputNumber);
InputNumber.displayName = "InputNumber";
InputNumber.defaultProps = inputNumberDefaultProps;

export { InputNumber as default };
//# sourceMappingURL=InputNumber.js.map
